import React from 'react';
import PortfolioUniversePage from './PortfolioUniversePage';

export default function LiquidityPage() {
  return (
    <PortfolioUniversePage
      strategyId="liquidity"
      portfolioHoldingType="LIQUIDITY"
    />
  );
}
